import React from "react";

/** The arrow glyph used by the card links and CTAs. Path taken from the reference. */
const Arrow = ({ className }: { className?: string }) => (
  <svg
    className={className}
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    aria-hidden="true"
    focusable="false"
  >
    <path d="M5 12h14M13 5l7 7-7 7" />
  </svg>
);

export default Arrow;
